import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpTiles
     * @memberof app
     *
     * @restrict E
     * @scope
     *
     * @description
     * Live and upcoming auctions for everyone in the blink of an eye with `<pkp-tiles></pkp-tiles>`.
     *
     * @param {boolean?} [seeAllLink=false] seeAllLink Set to `true` provides a link
     *  to an overview of all upcoming auctions.
     *
     * @author flzemke.btc
     */
    angular.module('app').directive('pkpTiles', pkpTiles);

    function pkpTiles(auctionResource, authService) {
        return {
            restrict: 'E',
            scope: {
                seeAllLink: '=?'
            },
            template: require('app/_directives/pkp-tiles.directive.html'),
            controller: PkpTilesCtrl,
            controllerAs: 'tiles'
        };

        function PkpTilesCtrl($scope, USER_ROLES) {
            var vm = this;
            vm.USER_ROLES = USER_ROLES;
            vm.loggedInUser = null;

            /** @type {boolean} */ vm.seeAllLink = $scope.seeAllLink === true;

            /** @type {boolean} */ vm.auctionTiles = null;
            /** @type {boolean} */ vm.isLoggedIn = null;
            /** @type {boolean} */ vm.uiLoadingTiles = true;
            /** @type {boolean} */ vm.uiErrorLoadingTiles = false;

            (function init() {
                getAuctionTiles();
                authService
                    .getLoggedInUserAsync()
                    .then(function (loggedInUser) {
                        vm.isLoggedIn = !!loggedInUser;
                        if (!!loggedInUser) {
                            vm.loggedInUser = loggedInUser;
                        }
                    });
            })();

            function getAuctionTiles() {
                auctionResource
                    .tiles(
                        undefined,
                        function (res) {
                            vm.auctionTiles = res;
                            vm.uiErrorLoadingTiles = false;
                        },
                        function () {
                            vm.uiErrorLoadingTiles = true;
                        }
                    )
                    .$promise.finally(function () {
                        vm.uiLoadingTiles = false;
                    });
            }
        }
    }
})();
